import Vue from 'vue';
import CreditsWidget from '@/plugins/graphql/queries/v2/grab-express-credits.gql';
import AnimatedNumber from 'animated-number-vue';
import moment from 'moment';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
export default Vue.extend({
    components: {
        AnimatedNumber,
    },
    mixins: [ViewportSizeMixin],
    apollo: {
        creditWidget: {
            query: CreditsWidget,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.grabExpressCredits;
            },
            fetchPolicy: 'cache-and-network',
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        dashboard: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            creditWidget: {},
        };
    },
    methods: {
        filterValue(value) {
            const options = this.$options;
            if (!!options && !!options.filters && !!options.filters.currency) {
                return options.filters.currency(value);
            }
            return '0.0';
        },
        latestDateText(date) {
            const formattedDate = moment(date).format('L');
            const baseText = 'Latest Top up approved on ';
            if (date) {
                return baseText.concat(formattedDate);
            }
            return 'No approved Top up';
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-card', {
            class: {
                'billing-widget': self.dashboard,
                'billing-widget mt-2 mr-2 -seashell-bg -credit': !self.dashboard,
            },
            props: {
                flat: true,
            },
        }, [
            createElement('v-layout', { class: 'column align-center justify-center pa-2' }, [
                createElement('v-layout', {
                    class: {
                        'align-center justify-space-between full-width': self.dashboard,
                        column: !self.dashboard,
                    },
                }, [
                    createElement('v-flex', { class: 'shrink' }, [
                        createElement('base-text', {
                            props: {
                                text: 'Shipping Credit',
                                fontSize10: self.mdAndUp && self.dashboard,
                                lineHeight11: self.mdAndUp && self.dashboard,
                                fontSize12: self.smAndDown && self.dashboard,
                                lineHeight14: self.smAndDown && self.dashboard,
                                fontSize14: !self.dashboard,
                                centered: !self.dashboard,
                            },
                            class: 'mb-0 mr-2 font-weight-black',
                        }),
                    ]),
                    createElement('v-flex', {
                        class: {
                            shrink: self.dashboard,
                            'text-xs-center': !self.dashboard,
                        },
                    }, [
                        createElement('animated-number', {
                            props: {
                                value: self.creditWidget.totalCredits,
                                duration: self.duration,
                                formatValue: self.filterValue,
                                xs12: self.xsOnly,
                            },
                            class: {
                                'orange--text text--darken-3 font-weight-bold': true,
                                'font-size-16 line-height-19': self.mdAndUp && self.dashboard,
                                'font-size-14 line-height-16': self.smAndDown && self.dashboard,
                                'font-size-24': !self.dashboard,
                            },
                        }),
                    ]),
                ]),
                createElement('v-layout', { class: { 'full-width': true } }, [
                    createElement('v-layout', { class: 'text-xs-center full-width' }, [
                        createElement('v-flex', { class: 'shrink text-xs-center' }, [
                            createElement('v-layout', [
                                createElement('v-flex', { class: 'shrink' }, [
                                    createElement('base-text', {
                                        props: {
                                            text: self.latestDateText(self.creditWidget.lastApprovedCredit),
                                            fontSize10: self.mdAndUp && (self.dashboard || !self.dashboard),
                                            lineHeight11: self.mdAndUp && self.dashboard,
                                            fontSize12: (self.smAndDown && self.dashboard) || !self.dashboard,
                                            lineHeight25: self.smAndDown && self.dashboard,
                                            textGreyLight3: true,
                                        },
                                        class: 'mb-0',
                                    }),
                                ]),
                            ]),
                        ]),
                    ]),
                ]),
            ]),
        ]);
    },
});
